import { forwardRef, memo, useEffect, useRef, useState } from 'react';
import { Input } from '~/components/common/forms';
import { motion } from 'framer-motion';
import { FieldError } from 'react-hook-form';
type CustomInputProps = {
   defaultValue: string;
   text: React.ReactNode;
   error?: FieldError | any;
};

const CustomInput = forwardRef<any, CustomInputProps & React.HTMLAttributes<HTMLInputElement>>(
   ({ text, ...props }, ref) => {
      const [clicked, setClicked] = useState(
         !!(props?.defaultValue || props?.defaultValue?.length)
      );
      const inputRef = useRef(ref as any);

      useEffect(() => {
         setClicked(!!(props?.defaultValue || props?.defaultValue?.length));
      }, [props?.defaultValue]);

      useEffect(() => {
         clicked && inputRef?.current?.focus();
      }, [clicked]);

      return (
         <div
            onBlur={() =>
               props?.defaultValue || props?.defaultValue?.length
                  ? setClicked(true)
                  : setClicked(false)
            }
            className="relative">
            <Input ref={inputRef} groupClassName="!mb-0" {...props} />
            <motion.div
               initial={{ height: 48, fontSize: '16px' }}
               animate={{ height: clicked ? 20 : 48, fontSize: clicked ? '12px' : '16px' }}
               transition={{ damping: 0, ease: 'backInOut' }}
               onClick={() => setClicked(true)}
               className="absolute top-0 w-full">
               <div className="flex items-center h-full mx-2 text-gray-400">{text}</div>
            </motion.div>
         </div>
      );
   }
);
CustomInput.displayName = 'CustomInput';
export default memo(CustomInput);
